import {Component, DestroyRef, inject, Input} from '@angular/core';
import {AccordiionComponent} from "@UI/accordiion/accordiion.component";
import {Router, RouterLink, RouterModule} from "@angular/router";
import {menu} from "./menu"
import {UserBadgeComponent} from "../user-badge/user-badge.component";
import {MatTooltip} from "@angular/material/tooltip";
import {Rights} from "@models/sportexam/rights";
import {CurrentRightsService} from "@services/current-rights.service";
import {filter, map, Observable, of} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {AsyncPipe} from "@angular/common";
import {EventData, EventService} from "@services/event.service";

@Component({
    selector   : 'app-menu',
    imports: [
        AccordiionComponent,
        RouterLink,
        RouterModule,
        UserBadgeComponent,
        MatTooltip,
        AsyncPipe,
    ],
    templateUrl: './menu.component.html',
    styleUrl   : './menu.component.scss'
})
export class MenuComponent{
    menu = menu;
    rights = inject(CurrentRightsService)
    destroyRef = inject(DestroyRef);
    @Input() reduced: boolean = true

    constructor(private router: Router, private eventService: EventService) {
    }

    isActive(route: string): boolean {
        return this.router.url.startsWith(route);
    }

    guardMenu(right: keyof Rights | boolean): Observable<boolean> {
        if (typeof right === 'boolean') {
            return of(right)
        }
        return this.rights.rights$
            .pipe(
                filter(Boolean),
                map(rights => {
                    return rights[right] ?? false
                }),
                takeUntilDestroyed(this.destroyRef),
            )
    }

    protected exit() {
        this.eventService.emit(new EventData('exit', this.router.url))
    }
}
